<template>
  <el-dialog
    title="八向图"
    :visible.sync="visible"
    width="1040px"
    :close-on-click-modal="false"
    @closed="resetDialog"
  >
    <div v-loading="loading" class="direction-image-dialog">
      <div class="direction-tip">图片可留空并分次补录，仅支持 HTTP/HTTPS 图片链接。</div>
      <div class="direction-grid">
        <div
          v-for="field in fields"
          :key="field.key || 'center'"
          class="direction-cell"
          :class="{ 'direction-center': field.center }"
        >
          <template v-if="!field.center">
            <div class="direction-label">{{ field.label }}</div>
            <div class="direction-preview">
              <img
                v-if="form[field.key] && !previewFailed[field.key]"
                :src="form[field.key]"
                :alt="field.label + '方向图片预览'"
                @error="onPreviewError(field.key)"
              >
              <span v-else>{{ form[field.key] ? '图片无法预览' : '暂无图片' }}</span>
            </div>
            <el-input
              v-model.trim="form[field.key]"
              :placeholder="field.label + '方向图片链接（可留空）'"
              clearable
              @input="onUrlInput(field.key)"
            />
          </template>
          <span v-else>产品中心</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="saving" :disabled="loading" @click="save">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
const PRODUCT_DIRECTION_IMAGE_API = require('../../api/productDirectionImage')
const DIRECTION_KEYS = [
  'front',
  'back',
  'left',
  'right',
  'left_top',
  'left_bottom',
  'right_top',
  'right_bottom'
]

export default {
  name: 'DirectionImageDialog',
  data () {
    return {
      visible: false,
      loading: false,
      saving: false,
      shapeSourceId: 0,
      productType: 0,
      form: this.emptyDirections(),
      previewFailed: this.emptyPreviewState(),
      fields: [
        { key: 'left_top', label: '左上' },
        { key: 'front', label: '前' },
        { key: 'right_top', label: '右上' },
        { key: 'left', label: '左' },
        { key: '', label: '', center: true },
        { key: 'right', label: '右' },
        { key: 'left_bottom', label: '左下' },
        { key: 'back', label: '后' },
        { key: 'right_bottom', label: '右下' }
      ]
    }
  },
  methods: {
    emptyDirections () {
      return DIRECTION_KEYS.reduce((directions, key) => {
        directions[key] = ''
        return directions
      }, {})
    },
    emptyPreviewState () {
      return DIRECTION_KEYS.reduce((state, key) => {
        state[key] = false
        return state
      }, {})
    },
    open (shapeSourceId, productType) {
      this.shapeSourceId = Number(shapeSourceId) || 0
      this.productType = Number(productType) || 0
      this.form = this.emptyDirections()
      this.previewFailed = this.emptyPreviewState()
      this.visible = true
      this.load()
    },
    load () {
      this.loading = true
      this.$axios.get(PRODUCT_DIRECTION_IMAGE_API.warehouseDetail, {
        params: {
          shape_source_id: this.shapeSourceId,
          product_type: this.productType
        },
        withCredentials: true
      }).then(response => {
        const result = response.data || {}
        if (Number(result.code) !== 200) {
          throw new Error(result.msg || '八向图读取失败')
        }
        const directions = result.data && result.data.directions
          ? result.data.directions
          : {}
        DIRECTION_KEYS.forEach(key => {
          this.$set(this.form, key, directions[key] || '')
          this.$set(this.previewFailed, key, false)
        })
      }).catch(error => {
        this.$message.error(this.errorMessage(error, '八向图读取失败'))
      }).then(() => {
        this.loading = false
      })
    },
    save () {
      const invalid = this.validateAndTrim()
      if (invalid) {
        this.$message.warning(invalid + '方向必须填写合法的 HTTP/HTTPS 图片链接')
        return
      }

      const formData = new FormData()
      formData.append('shape_source_id', this.shapeSourceId)
      formData.append('product_type', this.productType)
      DIRECTION_KEYS.forEach(key => {
        formData.append(key, this.form[key])
      })

      this.saving = true
      this.$axios.post(PRODUCT_DIRECTION_IMAGE_API.warehouseSave, formData, {
        withCredentials: true
      }).then(response => {
        const result = response.data || {}
        if (Number(result.code) !== 200) {
          throw new Error(result.msg || '八向图保存失败')
        }
        this.$message.success(result.msg || '保存成功')
        this.visible = false
      }).catch(error => {
        this.$message.error(this.errorMessage(error, '八向图保存失败'))
      }).then(() => {
        this.saving = false
      })
    },
    validateAndTrim () {
      for (let index = 0; index < DIRECTION_KEYS.length; index++) {
        const key = DIRECTION_KEYS[index]
        const value = String(this.form[key] || '').trim()
        this.$set(this.form, key, value)
        if (value && !/^https?:\/\/\S+$/i.test(value)) {
          const field = this.fields.find(item => item.key === key)
          return field ? field.label : key
        }
      }
      return ''
    },
    onUrlInput (key) {
      this.$set(this.previewFailed, key, false)
    },
    onPreviewError (key) {
      this.$set(this.previewFailed, key, true)
    },
    errorMessage (error, fallback) {
      if (error && error.response && error.response.data && error.response.data.msg) {
        return error.response.data.msg
      }
      if (error && error.message) {
        return error.message
      }
      return fallback
    },
    resetDialog () {
      this.shapeSourceId = 0
      this.productType = 0
      this.form = this.emptyDirections()
      this.previewFailed = this.emptyPreviewState()
      this.loading = false
      this.saving = false
    }
  }
}
</script>

<style scoped>
.direction-tip {
  margin-bottom: 16px;
  color: #909399;
  font-size: 14px;
}

.direction-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.direction-cell {
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
}

.direction-label {
  margin-bottom: 8px;
  color: #303133;
  font-weight: bold;
  text-align: center;
}

.direction-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  margin-bottom: 10px;
  overflow: hidden;
  color: #c0c4cc;
  background: #f5f7fa;
}

.direction-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.direction-center {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 18px;
  background: #f5f7fa;
}

@media (max-width: 900px) {
  .direction-grid {
    grid-template-columns: 1fr;
  }

  .direction-center {
    min-height: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/DirectionImageDialog.vue